/* @ngInject */
export default function UserManagementHeaderController(
  CurrentCourseManager,
) {
  const vm = this;
  vm.currentCourseManager = CurrentCourseManager;
}
